import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Frissítve:',
  breadcrumbs: {
    home: 'Honlap',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Miért bízhat bennünk',
        details: {
          text: '<h2>Miért bízhat bennünk</h2><p>A Natu.Care cikkeit tudományos kutatások, kormányzati honlapok adatai és más megbízható források alapján írjuk. A szövegek orvosokkal, táplálkozási szakemberekkel és más egészségügyi és szépségápolási szakértőkkel együttműködve készülnek. A cikkeket a közzététel előtt és a jelentős frissítések során felülvizsgáljuk.</p>',
          footerText: '<p>Tudjon meg többet <a href="/hu/rolunk/szerkesztesi-folyamat">szerkesztési folyamatun</a></p>'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Információk a reklámozásról',
        details: {
          text: '<h2>Információk a reklámozásról</h2><p>A Natu.Care tartalma tartalmazhat olyan termékekre mutató linkeket, amelyek eladásából jutalékot kaphatunk. A tartalom létrehozásakor magas szerkesztési normákhoz tartjuk magunkat, és ügyelünk arra, hogy objektívek legyünk a tárgyalt termékekkel kapcsolatban. Az affiliate linkek jelenlétét nem partnereink diktálják, és az általunk véleményezett termékeket teljesen függetlenül magunk választjuk ki.</p>',
          footerText: '<p>Tudjon meg többet a <a href="/hu/szabalyzat">szabalyzat</a></p>'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Szakértő által ellenőrizve',
      footerText: '<p>Tudjon meg többet <a href="/hu/rolunk/szerkesztesi-folyamat">szerkesztési folyamatun</a></p>'
    }
  },

  mediabar: {
    heading: 'A média rólunk:',
    href: '/hu/rolunk',
    title: 'Rólunk',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Zadbaj o zdrowy organizm',
    description: 'Spróbuj wysokiej jakości suplementów Natu.Care',
    button: {label: 'Zobacz produkty', href: 'https://natu.shop/collections'},
    picture: {alt: 'Młode, piękne kobiety z dobrą kondycją skóry.'}
  },

  authorship: {
    heading: 'Szerkesztőség',
    link: {
      label: 'Ismerje meg a csapatot',
      href: '/hu/rolunk/szerkesztok'
    }
  },

  similarArticles: {
    headingBlogList: 'Cikkek',
    headingBlogPost: 'Hasonló cikkek'
  }
};